<ng-container *ngIf="memberInfo.grade != '0002' && memberInfo.grade != '0004' && memberInfo.grade != '0007'">
  <div id="{{nPay_btnID}}" style="display: inline-flex;"></div>
  <div style="background: url(/assets/images/shop/bikemart_logobg.gif); width: 100%; height: 100%; position: fixed; top: 0; left: 0; z-index: 9999;" *ngIf="pay_load"></div>
</ng-container>
